import axios from "axios";
import { api } from "@/api";
import { app } from "@/main";

const types = {
  SET_SESSIONS: "SET_SESSIONS",
  UPDATE_SESSION: "UPDATE_SESSION",
  FETCH_FAILURE: "FETCH_FAILURE",
  SET_LOADING_STATUS: "SET_LOADING_STATUS",

  // filters
  SET_FAMILY: "SET_FAMILY",
  SET_BABYSITTER: "SET_BABYSITTER",
  SET_TYPE: "SET_TYPE",
  SET_STATE: "SET_STATE",
  SET_ORDER_BY: "SET_ORDER_BY",
  SET_ORDER_SORT: "SET_ORDER_SORT",
  SET_START_DATE: "SET_START_DATE",
  SET_END_DATE: "SET_END_DATE",
  SET_ID: "SET_ID",
  SET_CITY: "SET_CITY",

  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_ITEMS_PER_PAGE: "SET_ITEMS_PER_PAGE",
  SET_TOTAL_ITEMS: "SET_TOTAL_ITEMS",
};

export const state = {
  sessions: [],
  loading: false,

  family: null,
  babysitter: null,
  type: null,
  state: null,
  orderBy: null,
  orderSort: null,
  startDate: null,
  endDate: null,
  id: null,
  city: null,

  currentPage: 1,
  itemsPerPage: 10,
  total: null,
};

export const mutations = {
  [types.SET_SESSIONS](state: any, data: any) {
    state.sessions = [];
    state.sessions.push(...data.data);
    state.total = data.meta.total ? data.meta.total : 1;
  },
  [types.UPDATE_SESSION](state: any, data: any) {
    console.log(data);
    const exists = state.sessions.some(
      (session: any) => session.id === data.id
    );

    if (exists) {
      state.sessions.forEach((session: any) => {
        if (session.id == data.id) {
          session.id = data.id;
          session.babysitter = data.babysitter;
          session.state = data.state;
          session.sessionLength = data.sessionLength;
          session.type = data.type;
          session.accepts_new_babysitter = data.accepts_new_babysitter;
          session.preferred_babysitters_unavailable_at =
            data.preferred_babysitters_unavailable_at;
          session.address = data.address;
        }
      });
    } else {
      length = state.sessions.unshift(data);

      if (length > state.itemsPerPage) {
        state.sessions.pop();
      }
    }
  },

  [types.SET_FAMILY](state: any, data: string) {
    state.family = data;
  },

  [types.SET_BABYSITTER](state: any, data: string) {
    state.babysitter = data;
  },

  [types.SET_TYPE](state: any, data: number) {
    state.type = data;
  },

  [types.SET_STATE](state: any, data: number) {
    state.state = data;
  },

  [types.SET_ORDER_BY](state: any, data: string) {
    state.orderBy = data;
  },

  [types.SET_ORDER_SORT](state: any, data: string) {
    state.orderSort = data;
  },

  [types.SET_START_DATE](state: any, data: string) {
    state.startDate = data;
  },

  [types.SET_END_DATE](state: any, data: string) {
    state.endDate = data;
  },

  [types.SET_ID](state: any, data: number) {
    state.id = data;
  },

  [types.SET_CITY](state: any, data: string) {
    state.city = data;
  },

  [types.SET_CURRENT_PAGE](state: any, data: number) {
    state.currentPage = data;
  },

  [types.SET_ITEMS_PER_PAGE](state: any, data: number) {
    state.itemsPerPage = data;
  },

  [types.SET_LOADING_STATUS](state: any, bool: boolean) {
    state.loading = bool;
  },
};

export const actions = {
  connect({ commit }: any, params: any) {
    app.$echo
      .private("session")
      .listen("BabysittingSessionEvents\\SessionEvent", (e: any) => {
        commit(types.UPDATE_SESSION, e.babysittingSession);
      });
  },
  disconnect() {
    app.$echo.leave("session");
  },

  async fetchSessions({ commit, getters }: any, params: any) {
    try {
      /* if (state.sessions.length !== 0) {
                return;
            } */

      commit(types.SET_LOADING_STATUS, true);
      let params = getters.payload;

      const { data } = await axios.get(api.path("v1.admin.sessions"), {
        params: params,
      });

      commit(types.SET_SESSIONS, data);
      commit(types.SET_LOADING_STATUS, false);
    } catch (e) {
      commit(types.FETCH_FAILURE);
      commit(types.SET_LOADING_STATUS, false);
    }
  },

  async refreshSessions({ commit, getters }: any, params: any) {
    try {
      commit(types.SET_LOADING_STATUS, true);
      let params = getters.payload;

      const { data } = await axios.get(api.path("v1.admin.sessions"), {
        params: params,
      });

      commit(types.SET_SESSIONS, data);
      commit(types.SET_LOADING_STATUS, false);
    } catch (e) {
      commit(types.FETCH_FAILURE);
      commit(types.SET_LOADING_STATUS, false);
    }
  },

  clearPayload({ commit }: any, payload: any) {
    commit(types.SET_FAMILY, null);
    commit(types.SET_BABYSITTER, null);
    commit(types.SET_TYPE, null);
    commit(types.SET_STATE, null);
    commit(types.SET_ORDER_BY, null);
    commit(types.SET_ORDER_SORT, null);
    commit(types.SET_START_DATE, null);
    commit(types.SET_END_DATE, null);
    commit(types.SET_ID, null);
    commit(types.SET_CITY, null);

    commit(types.SET_CURRENT_PAGE, 1);
    commit(types.SET_ITEMS_PER_PAGE, 10);
  },

  setSessions({ commit }: any, payload: any) {
    commit(types.SET_SESSIONS, payload);
  },

  updateSession({ commit }: any, payload: any) {
    commit(types.UPDATE_SESSION, payload);
  },

  setFamily({ commit }: any, payload: any) {
    commit(types.SET_FAMILY, payload);
  },

  setBabysitter({ commit }: any, payload: any) {
    commit(types.SET_BABYSITTER, payload);
  },

  setType({ commit }: any, payload: any) {
    commit(types.SET_TYPE, payload);
  },

  setState({ commit }: any, payload: any) {
    commit(types.SET_STATE, payload);
  },

  setOrderBy({ commit }: any, payload: any) {
    commit(types.SET_ORDER_BY, payload);
  },

  setOrderSort({ commit }: any, payload: any) {
    commit(types.SET_ORDER_SORT, payload);
  },

  setStartDate({ commit }: any, payload: any) {
    commit(types.SET_START_DATE, payload);
  },

  setEndDate({ commit }: any, payload: any) {
    commit(types.SET_END_DATE, payload);
  },

  setId({ commit }: any, payload: any) {
    commit(types.SET_ID, payload);
  },

  setCity({ commit }: any, payload: any) {
    commit(types.SET_CITY, payload);
  },

  setCurrentPage({ commit }: any, payload: any) {
    commit(types.SET_CURRENT_PAGE, payload);
  },

  setItemsPerPage({ commit }: any, payload: any) {
    commit(types.SET_ITEMS_PER_PAGE, payload);
  },
};

export const getters = {
  sessions: (state: any) => state.sessions,
  sessionsLoading: (state: any) => state.loading,
  total: (state: any) => state.total,

  family: (state: any) => state.family,
  babysitter: (state: any) => state.babysitter,
  type: (state: any) => state.type,
  state: (state: any) => state.state,
  orderBy: (state: any) => state.orderBy,
  orderSort: (state: any) => state.orderSort,
  startDate: (state: any) => state.startDate,
  endDate: (state: any) => state.endDate,
  id: (state: any) => state.id,
  city: (state: any) => state.city,

  currentPage: (state: any) => state.currentPage,
  itemsPerPage: (state: any) => state.itemsPerPage,

  payload: (state: any) => {
    return {
      family: state.family,
      babysitter: state.babysitter,
      type: state.type,
      state: state.state,
      order_by: state.orderBy,
      order_sort: state.orderSort,
      start_date: state.startDate,
      end_date: state.endDate,
      id: state.id,
      city: state.city,

      page: state.currentPage,
      per_page: state.itemsPerPage,
    };
  },
};
